<template>
    <div v-if="$page.props.auth.check">
        <modal :with-padding="false" :show="show" :closeable="true" max-width="xl" @close="close">
            <div class="flex items-center justify-end mt-2 mr-2">
                <modal-close @close="close" />
            </div>
            <payout-method in-modal="true" @close="close" @open="open" />
        </modal>
    </div>
</template>

<script>
import ModalClose from "@/Components/ModalClose"
import PayoutMethod from "@/Pages/Settings/Profile/PayoutMethod"
import Modal from "@/Jetstream/Modal"

export default {
    components: {
        Modal,
        PayoutMethod,
        ModalClose,
    },

    props: {
        show: {
            default: true,
            type: Boolean,
        },
    },

    computed: {},

    data() {
        return {}
    },

    methods: {
        close() {
            this.$emit("update:show", false)
        },
        open() {
            this.$emit("update:show", true)
        },
    },
}
</script>
